// ach fields hidden when payout method clears ach info (e.g. Statement Credit)
export const ACH_INFO_FIELDS = ['achaccountnumber', 'achbankabanumber', 'achaccounttype'];

// ach fields shown only when payout method requires ach info (ACH only, not Check or Statement Credit)
export const ACH_REQUIRED_FIELDS = ['achcompanyid'];

// whether ach info should show for the chosen method (falls back to the method's own flag when not in list; defaults to true)
export const showAchInfoForMethod = (method, methodList) => {
    if (!method || method.id == null || !methodList) {
        return true;
    }
    const match = methodList.find(el => el?.id?.toString() === method.id.toString());
    return match ? !match.clearachinfo : !method.clearachinfo;
};

// whether a field should be visible for the chosen payout method (method may be undefined/null)
export const isAchFieldVisible = (columnId, method, showAchInfo) => {
    if (ACH_INFO_FIELDS.includes(columnId)) {
        return showAchInfo;
    }
    if (ACH_REQUIRED_FIELDS.includes(columnId)) {
        return method?.requireachinfo === true;
    }
    return true;
};

// dynamic args consumed by dynamicTransformation for ach fields
export const buildAchDynamicArgs = (method) => {
    const flags = {
        clearachinfo: method?.clearachinfo,
        requireachinfo: method?.requireachinfo
    };
    const args = {};
    [...ACH_INFO_FIELDS, ...ACH_REQUIRED_FIELDS].forEach(id => { args[id] = { ...flags }; });
    return args;
};
